import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '~/auth/use-auth';

import { getKYCStatus, startKYCVerification } from '../-api/api';

export function useKYCStatus() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['kyc', user?.urn],
    queryFn: async () => {
      const { data } = await getKYCStatus(user?.urn || '');
      // @ts-expect-error
      if (data?.error) {
        return null;
      }
      return data;
    },
    enabled: !!user?.urn,
  });
}

export function useStartKYC() {
  const { user } = useAuth();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      startKYCVerification(user?.urn || '', 'kyc', window.location.origin),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['kyc', user?.urn],
      });
    },
  });
}
